<template>
  <div class="container">
    <h1 >Coronavirus Reports</h1>
    <v-row>
      <v-col>
        <v-card style="box-shadow: 0px 0px 20px rgb(216, 216, 216);" class="stylecard1 mx-auto" >
          <v-card-title>
            <div><b>Global</b></div>
            <div class="go-corner" href="#">
      <div class="go-arrow">
         <v-icon color="#eeee">mdi-shield-plus</v-icon>
      </div>
    </div>
    
          </v-card-title>
          <v-card-text>
            <h4 >Confirmed: {{result.cases}}</h4>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card style="box-shadow: 0px 0px 20px rgb(216, 216, 216);" class="stylecard1 mx-auto" >
          <v-card-title>
            <div> <b>Global</b></div>
             
             <div class="go-corner" href="#">
      <div class="go-arrow">
        <v-icon color="#eeee">mdi-shield-off</v-icon>
      </div>
    </div>
          </v-card-title>
          <v-card-text>
            <h4 >Deaths: {{result.deaths}}</h4>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card style="box-shadow: 0px 0px 20px rgb(216, 216, 216);" class="stylecard1 mx-auto" >
          <v-card-title>
            <div><b>Global </b></div>
            <div class="go-corner-completed" href="#">
      <div class="go-arrow-completed">
         <v-icon color="#eeee">mdi-shield-star</v-icon>
      </div>
    </div>
          </v-card-title>
          <v-card-text>
            <h4 >Recovered: {{result.recovered}}</h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      
      <v-col>
        <v-card :loading="loading" @click="goTo('/states')" class="sub-card mx-auto" >
          <v-card-title>
            
            <div>Country : {{resultIndia.country}} </div>
            </v-card-title>
          <v-card-text >
            <v-row>
              <v-col >
<h6 class="text--primary">Cases:  {{resultIndia.cases}}</h6>
<h6 class="text--primary">Active Cases:  {{resultIndia.active}}</h6>

            <h6 class="text--primary">Deaths: {{resultIndia.deaths}}</h6>
            <h6 class="text--primary">Recovered: {{resultIndia.recovered}}</h6>
           <h6 class="text--primary">Today Deaths: {{resultIndia.todayDeaths}}</h6>
          
              </v-col>
              <v-col>
                <div class="form-inline">
                
  <h6 class="text--primary">Todays Cases  {{resultIndia.todayCases}} <span style="color:red;" class="mdi mdi-arrow-up"
  > </span>
  <p style="font-size:14px;" class="mx-auto mt-2 ">Last Updated {{new Date(res.lastRefreshed).toLocaleString()}}</p></h6>
          
                </div>
              </v-col>
            </v-row>
            </v-card-text>
            <v-card-actions> 
              <v-btn class="main-button mx-auto" style="background:#0f754e; color:#eee" > View Details </v-btn>
            </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="sub-card mx-auto">
          <v-card-text>
            <b>For Helpline Number</b>
      <div>Last Updated:{{ new Date(res.lastRefreshed).toLocaleString()}}</div>
            <v-simple-table  class="mt-3" fixed-header dense height="200px">
    <template v-slot:default>
      <thead >
        <tr>
          <th  class="text-left"><p>State</p></th>
          <th class="text-left"><p>Mobile Number</p></th>
          
          
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,idx) in res2.data.contacts.regional" :key="idx">
          <td>{{ item.loc }}</td>
          <td>{{ item.number }}</td>
          
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>
import {
  getCountryList,
  // getLocationsAll,
  getLocationsIndia,
  // getLocationById
} from "../services/country";
import { getCasesByState,
getContatcs } from "@/services/states";

export default {
  data() {
    return {
      res2:{
data:{
          contacts:{
            regional:null
          }
        
      }
      },
      
            res: {
        
      lastRefreshed:null,
      },

      loading:false,
      confirmed: null,
      deaths: null,
      country:null,

      locations: {
        timelines: null
      },

      result2: {
        latest: {
          confirmed: null
        }
      },
      resultIndia: {
          cases: null,
          deaths: null,
          recovered: null,
          todayDeaths:null,
          active:null,
        
      },

      result: {
        cases:null,
        deaths:null,
        recovered:null,
      }
    };
  },
  methods: {
    async callApis() {
      console.log("fetched country list ");
      try {
        const result = await getCountryList();
        console.log("Country List below : ", result);
        this.result = result;
        const resultIndia = await getLocationsIndia();
        console.log("locations below:", resultIndia);
        this.resultIndia = resultIndia;
        const res = await getCasesByState();
        console.log("all cases India List below : ", res);
        this.res = res;
        const res2 = await getContatcs();
        console.log("all ccontatc list below : ", res2);
        this.res2 = res2;

} catch (err) {
        console.log(err);
      }
    },
    goTo(path, params) {
      this.$router.push({
        path,
        params
      });
    },
  },
  mounted() {
    this.callApis();
    
  },
};

/* eslint-disable */
</script>
<style>
.sub-card
{
border-radius: 1rem !important;
  box-shadow: 0px 0px 40px rgb(216, 216, 216);
}
.go-corner {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  position: absolute;
  width: 30px;
  height: 30px;
  overflow: hidden;
  top: 0;
  right: 0;
  background-color: #0f754e;
  border-radius: 0 0px 0 25px;
}
.main-button{
  border-radius: 20px;
  padding: 10px !important;
box-shadow:2px 2px  25px #a1a8a5;
}
.go-arrow {
  margin-top: -4px;
  margin-right: -4px;
  color: white;
  font-family: courier, sans;
}
/* pending */

.go-arrow-pending {
  margin-top: -4px;
  margin-right: -4px;
  color: white;
  font-family: courier, sans;
}

.go-corner-completed {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  position: absolute;
  width: 30px;
  height: 30px;
  overflow: hidden;
  top: 0;
  right: 0;
  background-color:#0f754e;
  border-radius: 0 0px 0 25px;
}

.go-arrow-completed {
  margin-top: -4px;
  margin-right: -4px;
  color: white;
  font-family: courier, sans;
}

.stylecard1 {
  display: block;
  position: relative;
  text-decoration: none;
  z-index: 0;
  overflow: hidden;
  border-radius: 1rem !important;
}
.stylecard1:before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -29px;
  right: 152px;
  background: linear-gradient(to left, #207c59, #26a067) !important;
  height: 34px;
  width: 32px;
  border-radius: 32px;
  -webkit-transform: scale(1);
          transform: scale(1);
  -webkit-transform-origin: 50% 50%;
          transform-origin: 50% 50%;
  -webkit-transition: -webkit-transform 0.25s ease-out;
  transition: -webkit-transform 0.25s ease-out;
  transition: transform 0.25s ease-out;
  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
}
.stylecard1:hover:before {
  -webkit-transform: scale(21);
          transform: scale(21);
}

.stylecard1:hover p {
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  color: rgba(255, 255, 255, 0.8);
}
.stylecard1:hover h4  {
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  color: #ffffff;
  
}
.stylecard1:hover .fa{
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  color: #ffffff !important;
  
}

.stylecard1:hover{
   box-shadow: none !important;
}

</style>